export const version = '2.10.9';
//# sourceMappingURL=version.js.map